<template>
    <div class="banner" >
        <swiper :options="swiperOptiona" ref="mySwipers" class="swiper"  >
            <swiper-slide class="item" v-for="(item,index) in banner" :key="index">
                <img :src="`http://www.bodenstil.com/${item.picurl}`" alt="">
                <div class="text">
                  <p class="t1">{{item.title}}</p>
                    <p class="t2"  v-html="item.description"></p>
                </div>
            </swiper-slide>
        </swiper>

        <swiper :options="swiperOption2" ref="mySwipers2" class="swiper2"  >
            <swiper-slide class="item" v-for="(item,index) in banner" :key="index">
              <div class="one">
                 <p>{{item.title}}</p>
                  <div class="circle">
                      <svg id="ec8ewxfout1i1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 38 38" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">

                          <circle id="ec8ewxfout1i2" r="17.520910" transform="matrix(0 -1 1 0 19.00000000000001 18.99999999999999)" fill="none" stroke="rgb(255,255,255)" stroke-width="0.750000" stroke-miterlimit="10" stroke-dashoffset="110.090000" stroke-dasharray="110.090000"/>
                      </svg>
                  </div>
              </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import { getHomeInfo} from '../util/lang'
    import '../common/jquery-1.11.3.min'
    export default {
        name: "banner",
        data(){
            let _this=this
            return{
                swiperOptiona:{
                    loop: false,
                    effect: 'fade',
                    init: false,
                    speed:1000,
                   autoplay: {
                   delay: 4000,
                    },
                },
                swiperOption2:{
                    loop: false,
                    direction : 'vertical',
                    init: false,
                    slideToClickedSlide: true,
                    centeredSlides : true,
                    slidesPerView : 3,
                    speed:1000
            },
            }
        },
        props:[
            'banner'
        ],
        components: {
            swiper,
            swiperSlide,
        },
        mounted(){
            setTimeout(()=>{
                this.$refs.mySwipers.swiper.init()
                this.$refs.mySwipers2.swiper.init()
                const swiperTop = this.$refs.mySwipers.swiper
                const swiperThumbs = this.$refs.mySwipers2.swiper
                swiperTop.controller.control = swiperThumbs
                swiperThumbs.controller.control = swiperTop
            })
        },
        methods:{
            gotoAbout(){
                window.open('/about.html','_blank')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .banner{
        width:100%;
        position: relative;
        transition: all 600ms;
        .swiper{
            height:100vh;
            overflow: hidden;
            .item{
                position: relative;
                overflow: hidden;
                  img{
                    width:100%;
                    height:100%;
                    object-fit: cover;
                    display: block;
                    z-index: 1;
                    cursor: pointer;
                    transform: scale(1);
                    transition: all 5s;
                }
                .text{
                    position: absolute;
                    left:10%;
                    width:80%;
                    top:35%;
                    .t1{
                        font-size: 30px;
                        color:white;
                        font-family: "SOURCEHANSANSCN-LIGHT";
                        text-transform: uppercase;
                        line-height: 53px;
                        -webkit-transform: translateY(80px);
                        transform: translateY(80px);
                        opacity: 0;
                        -webkit-transition: all 1s;
                        transition: all 1s;
                        text-align: center;letter-spacing: 4px;
                        position: relative;
                        padding-bottom: 15px;
                        &::after{
                            content:'';
                            display: inline-block;
                            width:6%;
                            height:1px;
                            background-color: white;
                            position: absolute;
                            bottom:0;
                            left:47%;
                        }
                    }
                    .t2{
                        font-family: "it";
                        font-size: 15px;
                        color:white;
                        text-align: center;
                        opacity: 0;
                        line-height: 30px;
                        transform: translateY(100px);
                        transition: all 2s;
                        transition-delay: 300ms;
                        margin: 40px auto;
                        text-transform: uppercase;
                        font-weight: lighter;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        /*&::after{*/
                        /*    content:'';*/
                        /*    display: inline-block;*/
                        /*    width:140px;*/
                        /*    height:1px;*/
                        /*    background:rgba(255,255,255,1);*/
                        /*    margin-top: 20px;*/
                        /*}*/
                    }
                }
            }
            .swiper-slide-active{
                img{
                    transform: scale(1.05);
                }
                .text{
                    .t1,.t2{
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            }
        }
        .swiper2{
            position: absolute;
            right:5%;
            top:28%;
            z-index: 1000;
            width:10%;
            height:200px;
            padding: 30px 0;
            .item{
                margin-top: 10px;
                .one{
                    width:100%;
                    display:flex;
                    flex-direction: row;
                    cursor: pointer;
                    p{
                        font-family: "itbook";
                        font-size: 14px;
                        color:white;
                        opacity: .4;
                        transition: all 600ms;
                        width:70%;
                    }
                    .circle{
                        width:30px;
                        height:30px;
                        background:rgba(0,0,0,.3);
                        border-radius:50%;
                        position: relative;
                        &::before{
                            content:'';
                            display: inline-block;
                            width:6px;
                            height:6px;
                            background:rgba(255,255,255,1);
                            border-radius:50%;
                            left:12px;
                            top:12px;
                            position: absolute;
                        }
                    }
                }
            }
            .swiper-slide-active{
                .one{
                    p{
                        opacity: 1;
                    }
                   .circle{
                       svg{
                           circle{
                               animation: ec8ewxfout1i2_s_da 4s linear 1 normal forwards;
                           }
                           @keyframes ec8ewxfout1i2_s_da { 0% {stroke-dasharray: 110.090000;animation-timing-function: cubic-bezier(1,0.040000,0.965000,0.145000)} 100% {stroke-dasharray: 360} }

                       }

                   }
                }
            }
        }
        @media screen and (max-width: 1440px) and (min-width: 1000px){
            .swiper{
            }
        }
        @media screen and (max-width: 1000px){
            .swiper{
              .item{
                 .text{
                     .t1{
                         font-size: 35px;
                         img{
                             width: 100%;
                         }
                         span{
                             font-size: 22px;
                         }
                     }
                     .t2{
                         font-size: 12px;
                     }
                 }
              }
            }
            .swiper2{
                display: none;
            }
        }
    }
</style>
<style scoped>
    .banner .swiper-pagination {
        bottom: 10%;
        width: 100%;
        left:0;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet {
        position: relative;
        width: 80px;
        height: 1px;
        opacity: 0.6;
        margin: 0 15px;
        background-color: rgba(255,255,255,.2);
        border-radius: 0;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet:focus{
        outline: none;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet i{
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 100%;
        background-color: #fff;
        opacity:1;
    }
</style>
